import { previewFeedRanking } from "../../../../firebase";

/**
 * Feed Lab hook: exercises the in-house feed ranker (previewFeedRanking) that
 * replaces AddSearch for the Listen feed. Returns the ranked candidate pool with
 * per-item score breakdowns, so the admin can validate/tune ranking before
 * flipping `useInternalFeed`.
 *
 * See docs/ADDSEARCH_REPLACEMENT_PLAN.md (Phase 3 / Feed Lab).
 *
 * @param {Object} params
 * @param {number} [params.limit=25] - number of top items to return
 * @param {Object} [params.configOverride] - partial config for what-if tuning (not saved)
 * @param {string} [params.uid] - viewer uid for affinity personalization
 * @param {{lat:number,long:number}} [params.nearby] - viewer location for proximity bonus
 * @returns {Promise<Object>} preview payload (results, poolSize, configUsed, tookMs, …)
 */
export const runFeedPreview = async ({
  limit,
  configOverride,
  uid,
  nearby,
} = {}) => {
  const payload = {};
  if (limit) payload.limit = limit;
  if (configOverride) payload.configOverride = configOverride;
  if (uid) payload.uid = uid;
  if (nearby) payload.nearby = nearby;
  const res = await previewFeedRanking(payload);
  return res.data;
};
